import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\CopyAssignedPeopleToEventsOfDossier::__invoke
* @see app/Http/Controllers/Planning/CopyAssignedPeopleToEventsOfDossier.php
* @route '/api/planning/copy-assign-people-dossier/{event}'
*/
const CopyAssignedPeopleToEventsOfDossier = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyAssignedPeopleToEventsOfDossier.url(args, options),
    method: 'post',
})

CopyAssignedPeopleToEventsOfDossier.definition = {
    methods: ["post"],
    url: '/api/planning/copy-assign-people-dossier/{event}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\CopyAssignedPeopleToEventsOfDossier::__invoke
* @see app/Http/Controllers/Planning/CopyAssignedPeopleToEventsOfDossier.php
* @route '/api/planning/copy-assign-people-dossier/{event}'
*/
CopyAssignedPeopleToEventsOfDossier.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return CopyAssignedPeopleToEventsOfDossier.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\CopyAssignedPeopleToEventsOfDossier::__invoke
* @see app/Http/Controllers/Planning/CopyAssignedPeopleToEventsOfDossier.php
* @route '/api/planning/copy-assign-people-dossier/{event}'
*/
CopyAssignedPeopleToEventsOfDossier.post = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyAssignedPeopleToEventsOfDossier.url(args, options),
    method: 'post',
})

export default CopyAssignedPeopleToEventsOfDossier